  <template>
      <v-container fluid ma-3 pa-3>
          <v-layout row wrap justify-center>
              <v-flex>
                  <span class="style_title">Trend Radar</span>
                  <br>
                  <br>
                  <div>
                      <span class="style_description" style="white-space: pre-line">The Discovery radar is an instrument through which the user can obtain information of interest about trends.
                      </span>

                    <br>

                          <v-img
                              max-width="300"
                              :src="require('@/assets/img/help/radar.png')"
                          >
                  </v-img>

                      <br>

                      <span class="style_paragraph" style="white-space: pre-line">How to read</span>
                      <br>
                      <span class="style_description" style="white-space: pre-line">Through the radar it is possible to choose 2 visualization types of trends:
                          <ul>
                              <li>In the Technology Radar, trends are mapped against Digital Focus Area</li>
                              <li>In the Business Radar, trends are mapped against Market Sectors</li>
                          </ul>
  In both cases, startups are located in the radar from their classes, adoption status, business relevance and impact.
  Each point on the plot represent a trend. It is possible to click on it to view some informations like the relative articles and the associated startups.
  It's easy to zoom the plot dragging your mouse on it and when you're done just double click on the view to restore its initial state.</span>


                  </div>
                  <br>


              </v-flex>
          </v-layout>
      </v-container>
  </template>

  <script>

      export default {
          name: "RadarHelp",
          components: {},
          data() {
              return {

              }
          },

          methods: {

          }
      }
  </script>

  <style scoped>
      .style_description{
          font-size: 18px;
      }

      .style_paragraph{
          font-size: 22px;
          font-weight: bold;
      }

      .style_title{
          font-size: 34px;
          font-weight: bold;
      }

  </style>